<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>{{ $route.name }}</b-navbar-brand>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <b-row>
              <b-col md="3">
                <label>Common Filter</label>
                <b-form-input
                  type="text"
                  :formatter="capitalizeAll"
                  placeholder="Search Common Filter"
                  id="commonFilter"
                  name="commonFilter"
                  autocomplete="off"
                  v-model="commonFilter"
                  @input="getInvoiceDocListFunc"
                ></b-form-input>
              </b-col>
              <b-col md="3">
                <label>Client</label>
                <model-list-select
                  :list="$store.getters['common/getAllClientList']"
                  id="clientNamenew"
                  v-model="clientFilter"
                  option-value="clientName"
                  option-text="clientName"
                  placeholder="Select Client Name"
                  @input="getInvoiceDocListFunc"
                ></model-list-select>
              </b-col>
              <b-col cols="12" v-if="getInvoiceDocList.length > 0">
                <div class="table-responsive tableMain gutr">
                  <b-table
                    show-empty
                    stacked="md"
                    :items="getInvoiceDocList"
                    responsive
                    :fields="Invfields"
                    primary-key="InvId"
                    :per-page="pagination.perPage"
                    :current-page="pagination.currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    class="position-relative"
                  >
                    <template slot="InvId" slot-scope="row0">
                      <span>{{
                        row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                      }}</span>
                    </template>
                    <template slot="InvNO" slot-scope="row0">
                      <span>Inv NO : {{ row0.item.InvNO }}<br /></span>
                      <span>Inv Date : {{ row0.item.InvDate }}<br /></span>
                    </template>
                    <template slot="JOBNO" slot-scope="row0">
                      <span>Job NO : {{ row0.item.JOBNO }}<br /></span>
                      <span>Job Date : {{ row0.item.JOBDate }}<br /></span>
                    </template>
                    <template slot="fk_tally_id" slot-scope="row1">
                      <b-button
                        id="show-btn"
                        size="xs"
                        style="font-size: 0.675rem"
                        class="mt-2"
                        :variant="row1.item.AddTypevalue == '1' ? 'info' : 'danger'"
                        @click="addInv(row1.item)"
                      >
                        {{ row1.item.AddTypeLabel }}
                        <i class="fa fa-plus" aria-hidden="true"></i
                      ></b-button>

                      <!-- variant="outline-primary" -->
                    </template>
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>

        <b-card class="formCard">
          <b-card-text>
            <div>
              <b-card class="mt-1" v-for="(itm, idx) in invArr" :key="idx">
                <!-- <div class="d-flex align-items-center">
                  
                </div> -->

                <b-row align-v="start">
                  <b-col sm="3"
                    ><label>Invoice No <span class="error">*</span> </label>
                    <h5>
                      <b-badge :variant="'primary'">{{ itm.InvNO }}</b-badge>
                    </h5>

                    <span class="error" v-if="itm.invType_err ? true : false">{{
                      itm.invType_err
                    }}</span>
                  </b-col>
                  <b-col sm="3"
                    ><label>Job No <span class="error">*</span> </label>
                    <h5>
                      <b-badge :variant="'primary'">{{ itm.JOBNO }}</b-badge>
                    </h5>
                  </b-col>
                  <!-- <b-col sm="3">
                    <label>Invoice Documents <span class="error"></span></label>
                    <Single-Upload
                      :index="idx"
                      :second_index="0"
                      :multiple="false"
                      :documentName="'ReverseTallyInv_Doc_'"
                      :otherDocName="'ReverseTallyInv_Doc_'"
                      :folderName="itm.JOBNO"
                      :accept="'*'"
                      v-model="itm.inv_doc_url"
                      :state="Boolean(itm.inv_doc_url)"
                      :assign_no="itm.JOBNO ? itm.JOBNO : 'INVOICE'"
                      :fileAllModuleId="itm.allModuleId"
                    />
                    <a
                      v-if="itm.doc_path && itm.inv_doc_url"
                      :href="
                        `${docURL}/ASSIGNMENT_UPLOADS/` +
                        itm.doc_path +
                        '/' +
                        itm.inv_doc_url
                      "
                      target="_blank"
                      download
                      >--View</a
                    >
                  </b-col> -->
                  <b-col sm="3" v-if="idx != 0">
                    <b-button
                      class="ml-auto"
                      id="show-btn"
                      variant="danger"
                      size="xs"
                      style="font-size: 0.675rem"
                      @click="removeInv(idx)"
                    >
                      Remove Inv <i class="fa fa-plus" aria-hidden="true"></i
                    ></b-button>
                  </b-col>
                </b-row>
              </b-card>
              <b-row>
                <b-col cols="3">
                  <label>Sent By :</label>
                  <model-list-select
                    :list="$store.getters['common/getAllUserList']"
                    id="fk_inv_doc_sent_by"
                    v-model="invoiceDocDeatils.fk_inv_doc_sent_by"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Created User"
                  ></model-list-select>
                </b-col>
                <b-col md="2"
                  ><label for="ColumnName">Invoice Sent Through :</label><br />
                  <div class="checkbox-inline">
                    <b-form-checkbox
                      id="checkbox-Email"
                      v-model="invoiceDocDeatils.inv_doc_sent_trough_email"
                      name="checkbox-Email"
                      value="Email"
                      unchecked-value=""
                      class="mr-2"
                    >
                      Email
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-Courier"
                      v-model="invoiceDocDeatils.inv_doc_sent_trough_courier"
                      name="checkbox-Courier"
                      value="Courier"
                      unchecked-value=""
                    >
                      Courier
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="checkbox-ByHand"
                      v-model="invoiceDocDeatils.inv_doc_sent_by_hand"
                      name="checkbox-ByHand"
                      value="By Hand"
                      unchecked-value=""
                    >
                      By Hand
                    </b-form-checkbox>
                  </div>
                </b-col>
                <b-col
                  md="2"
                  v-if="invoiceDocDeatils.inv_doc_sent_trough_email == 'Email'"
                >
                  <label for="ColumnName">Email Date :</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="amount"
                    name="amount"
                    v-model="invoiceDocDeatils.inv_doc_date"
                    type="date"
                  ></b-form-input>
                </b-col>
                <b-col
                  md="3"
                  v-if="invoiceDocDeatils.inv_doc_sent_trough_courier == 'Courier'"
                >
                  <label for="ColumnName">Docket No :</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="amount"
                    name="amount"
                    v-model="invoiceDocDeatils.inv_doc_Docket_No"
                    type="text"
                  ></b-form-input>
                </b-col>
                <b-col
                  md="2"
                  v-if="invoiceDocDeatils.inv_doc_sent_trough_courier == 'Courier'"
                >
                  <label for="ColumnName">Courier Date :</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="inv_doc_date_courier"
                    name="inv_doc_date_courier"
                    v-model="invoiceDocDeatils.inv_doc_date_courier"
                    type="date"
                  ></b-form-input>
                </b-col>

                <b-col
                  md="2"
                  v-if="invoiceDocDeatils.inv_doc_sent_by_hand == 'By Hand'"
                >
                  <label for="ColumnName">By Hand Date :</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="amount"
                    name="amount"
                    v-model="invoiceDocDeatils.inv_doc_by_hand_date"
                    type="date"
                  ></b-form-input>
                </b-col>

                <b-col md="12">
                  <label for="ColumnName">Remarks :</label>
                  <b-form-textarea
                    :formatter="capitalizeAll"
                    rows="5"
                    id="name-input"
                    v-model="invoiceDocDeatils.inv_doc_remark"
                    required
                  ></b-form-textarea>
                </b-col>
                <b-col md="12">
                  <label for="ColumnName">Invoices Doc :</label>
                  <multi-file-uploader
                    :style="'height: 80px; background: darkgray; width: 100%'"
                    :documentName="'ReverseTallyInv_Doc_-'"
                    :otherDocName="'ReverseTallyInv_Doc_-'"
                    :folderName="'ReverseTallyInv_Doc'"
                    :accept="'*'"
                    :assign_no="'ReverseTallyInv_Doc'"
                    :multiple="true"
                    v-model="invoiceDocDeatils.singleUpload"
                    :state="Boolean(invoiceDocDeatils.singleUpload)"
                    :fileAllModuleId="'InvoicesDoc'"
                  ></multi-file-uploader>
                </b-col>

                <b-col md="12">
                  <span v-if="invoiceDocDeatils.singleUpload">
                    <b v-if="invoiceDocDeatils.singleUpload.length > 0">
                      <span
                        v-for="(item_doc, index_doc) in sanitizedArray(invoiceDocDeatils.singleUpload)"
                        :key="index_doc"
                      >
                        <a
                          v-if="item_doc != ''"
                          href="javascript:void(0)"
                          @click="printInvDoc(item_doc)"
                          >View Document - {{ index_doc + 1 }}</a
                        >
                        <br />
                      </span>
                    </b>
                    <b v-else>
                      <a
                        v-if="
                          invoiceDocDeatils.singleUpload != '' &&
                          invoiceDocDeatils.singleUpload != undefined &&
                          invoiceDocDeatils.singleUpload != null
                        "
                        href="javascript:void(0)"
                        @click="printInvDoc(invoiceDocDeatils.singleUpload)"
                        >View Document</a
                      >
                    </b>
                  </span>
                </b-col>

                <!-- <b-col cols="3">
                  <b-button
                    id="show-btn"
                    size="sm"
                    class="mt-2"
                    variant="outline-primary"
                    @click="addInv"
                  >
                    Add Inv Doc <i class="fa fa-plus" aria-hidden="true"></i
                  ></b-button>
                </b-col> -->
              </b-row>

              <md-layout md-gutter class="gutr center">
                <md-layout md-flex="100">
                  <b-button
                    v-if="invArr.length > 0"
                    class="mt-3"
                    variant="primary"
                    id="addButtonLoaderSB"
                    @click="addInvDetail"
                    >Save & Submit
                  </b-button>

                  <md-spinner
                    md-indeterminate
                    id="loaderSB"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>
            </div>
          </b-card-text>
        </b-card>

        <md-dialog-confirm
          :md-content-html="alert.content"
          :md-ok-text="alert.ok"
          ref="popMailAfter"
        ></md-dialog-confirm>

        <md-dialog-confirm
          :md-content-html="alert.content"
          :md-ok-text="alert.ok"
          ref="addPop"
        ></md-dialog-confirm>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import Multiselect from "vue-multiselect";

import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import MultiFileUploader from "../common/MultiFileUploader.vue";
// import SingleUpload from "../common/singleUpload.vue";
import AccountService from "../../services/AccountService.js";
import CommonService from "../../services/CommonService.js";

export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.getInvoiceDocListFunc();
    if (globalPermissionStatus("Pridel Document") || globalPermissionStatus("Accounts")) {
      this.$store.dispatch("setCurrentRoute", "/billInvList/multiInv");
      if (this.$sessionsStorage.get("port_allModuleId")) {
        // this.getSingleInvDetail();
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    port_JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getSingleInvDetail();
      },
      deep: true,
    },
  },

  data() {
    return {
      
      PaginationCount: 0,
      totalRows: 0,
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      Invfields: [
        {
          key: "InvId",
          mainkey: "InvId",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "InvNO",
          mainkey: "InvNO",
          label: "Inv No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "JOBNO",
          mainkey: "JOBNO",
          label: "Job No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "ClientName",
          mainkey: "ClientName",
          label: "CLient Name.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "fk_tally_id",
          mainkey: "fk_tally_id",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      commonFilter: "",
      clientFilter: "",
      getInvoiceDocList: [],
      ALLMODULE: "",
      JOBSERIES: "",
      ALLMODULE: "",
      JOBSERIES: "",
      DocJOBNO: "",
      DocInvNO: "",
      invoiceDocDeatils: {
        singleUpload: [],
        inv_doc_id: "",
        InvId: "",
        InvNO: "",
        InvType: "",
        JOBNO: "",
        allModuleId: "",
        fk_all_module_id: "",
        fk_rev_tally_id: "",
        fk_tally_id: "",
        inv_doc_Common_ID: "",
        fk_inv_doc_sent_by: "",
        inv_doc_sent_trough_email: "",
        inv_doc_sent_trough_courier: "",
        inv_doc_sent_by_hand: "",
        inv_doc_Docket_No: "",
        inv_doc_date: "",
        inv_doc_date_courier: "",
        inv_doc_by_hand_date: "",
        inv_doc_url: "",
        inv_doc_name: "",
        inv_doc_remark: "",
        doc_path: "",
        inv_doc_folder_name: "",
      },
      InvoiceTypeList: [
        {
          DVal: "1",
          DText: "Email",
        },
        {
          DVal: "2",
          DText: "Courier",
        },
      ],

      files: [],
      syncFlag: false,
      selectDateFormat,

      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      validateInv: true,
      fileIndex: "0",
      // singleUpload: "",
      invArr: [],
    };
  },
  created() {
    eventBus.$on("fileuploaded", (file) => {
      console.log("fileuploaded=>", file);
      this.invoiceDocDeatils.singleUpload = file.split(",");
    });

    // eventBus.$on("fileuploaded", (file) => {
    //   console.log("fileuploaded=>", file);
    //   this.singleUpload = file;
    // });
    // eventBus.$on("fileuploadedindex", (fileindex) => {
    //   console.log("fileuploadedindex=>", fileindex);
    //   this.fileIndex = fileindex;
    //   this.invArr[fileindex].inv_doc_url = this.singleUpload;
    // });
  },

  mounted() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    MultiSelect,
    // Loading,
    CustomLoader,
    BannerComponent,
    Multiselect,
    MultiFileUploader,
    // SingleUpload,
  },
  computed: {},
  methods: {
    sanitizedArray(inv_doc) {
      // Use the map method to replace "\n" with []
      const replacedArray = inv_doc.map((item) => {
        if (item === "\n") {
          return [];
        } else {
          return item;
        }
      });

      // Flatten the replacedArray and remove empty arrays
      const flattenedArray = replacedArray.reduce((acc, curr) => {
        if (Array.isArray(curr) && curr.length === 0) {
          return acc;
        }
        return acc.concat(curr);
      }, []);

      console.log("inv_doc2 =>", flattenedArray);
      return flattenedArray;
    },
    printInvDoc(inv_doc) {
      let key = "ASSIGNMENT_UPLOADS/ReverseTallyInv_Doc/" + inv_doc;
      this.openSignedDocument(key);
    },
    AddRemoveLabel() {
      this.getInvoiceDocList.forEach((val1, key1) => {
        val1.AddTypevalue = "1";
        val1.AddTypeLabel = "Add";
      });
      if (this.getInvoiceDocList.length > 0 && this.invArr.length > 0) {
        for (let i = 0; i < this.invArr.length; i++) {
          for (let j = 0; j < this.getInvoiceDocList.length; j++) {
            if (this.getInvoiceDocList[j].InvId === this.invArr[i].InvId) {
              this.getInvoiceDocList[j].AddTypevalue = "2";
              this.getInvoiceDocList[j].AddTypeLabel = "Remove";
              break;
            }
          }
        }
      }
    },
    getInvoiceDocListFunc() {
      this.getInvoiceDocList = [];
      let payload = {};
      payload = {
        itemCode: "getInvoiceDocList",
        commonFilter: this.commonFilter,
        clientFilter: this.clientFilter,
      };

      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.FLAG == 1) {
            this.getInvoiceDocList = [];
            if (data.getInvoiceDocList.length > 0) {
              this.getInvoiceDocList = data.getInvoiceDocList;
              this.AddRemoveLabel();

              this.totalRows = data.totalRows;
            }
          }
        })
        .catch((error) => {
          console.log("Catch on getInvoiceDocList Error: ", error);
        });
    },
    reset() {
      this.items = []; // reset
    },
    updateInvoice(item, idx) {
      let getData = this.getInvoiceDocList.filter((invoice) => item == invoice.InvId);
      let itemData = getData[0];
      console.log("item=>", getData);
      this.invArr[idx].inv_doc_id = "";
      // this.invArr[idx].InvId=item.InvId;
      this.invArr[idx].InvNO = itemData.InvNO;
      this.invArr[idx].InvType = itemData.InvType;
      this.invArr[idx].JOBNO = itemData.JOBNO;
      this.invArr[idx].allModuleId = itemData.allModuleId;
      this.invArr[idx].fk_all_module_id = itemData.fk_all_module_id;
      this.invArr[idx].fk_rev_tally_id = itemData.fk_rev_tally_id;
      this.invArr[idx].fk_tally_id = itemData.fk_tally_id;
      this.invArr[idx].inv_doc_url = "";
      this.invArr[idx].inv_doc_name = "";
      this.invArr[idx].doc_path = itemData.JOBNO
        ? itemData.JOBNO.replaceAll("/", "_")
        : "INVOICE";
      this.invArr[idx].inv_doc_folder_name = itemData.JOBNO
        ? itemData.JOBNO.replaceAll("/", "_")
        : "INVOICE";
      console.log("this.invArr[idx]=>", this.invArr[idx]);
    },

    addInv(item) {
      let data = this.invArr.filter((val, key) => {
        return val.InvId === item.InvId;
      });
      if (item.AddTypevalue == "1") {
        let obj = {
          inv_doc_id: "",
          InvId: item.InvId,
          InvNO: item.InvNO,
          InvType: item.InvType,
          JOBNO: item.JOBNO,
          allModuleId: item.allModuleId,
          fk_all_module_id: item.fk_all_module_id,
          fk_rev_tally_id: item.fk_rev_tally_id,
          fk_tally_id: item.fk_tally_id,
          inv_doc_Common_ID: "",
          inv_doc_url: "",
          inv_doc_name: "",
          doc_path: item.JOBNO ? item.JOBNO.replaceAll("/", "_") : "INVOICE",
          inv_doc_folder_name: item.JOBNO ? item.JOBNO.replaceAll("/", "_") : "INVOICE",

          InvNO_err: "",
          inv_doc_url_err: "",
        };
        if (data.length <= 0) {
          this.invArr.push(obj);
        }
      } else if (item.AddTypevalue == "2") {
        let index = this.invArr.findIndex((main) => main.InvId === item.InvId);

        if (index !== -1) {
          this.invArr.splice(index, 1);
        }
      }

      this.AddRemoveLabel();
      console.log(this.invArr.length);
    },

    removeInv(index) {
      this.invArr.splice(index, 1);
      this.AddRemoveLabel();
    },
    goBack() {
      window.history.go(-1);
    },

    validateInvDetail() {
      let validate_new = true;
      let i = 0;
      let errCount = 0;
      let MainARR = this.invArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].InvNO == "") {
          this.invArr[j]["InvNO_err"] = "Invoice No Field is Required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.invArr[j]["InvNO_err"] = "";
          validate_new = true;
        }

        // if (MainARR[j].inv_doc_url == "") {
        //   this.invArr[j]["inv_doc_url_err"] = "Invoice Document Field is Required";
        //   validate_new = false;
        //   ++errCount;
        //   break;
        // } else {
        //   this.invArr[j]["inv_doc_url_err"] = "";
        //   validate_new = true;
        // }
      }
      console.log("this.invArr=>", this.invArr);
      if (errCount > 0) {
        this.validateInv = false;
      }
      if (validate_new == false) {
        this.validateInv = false;
      } else {
        this.validateInv = true;
      }
    },
    addInvDetail() {
      let array = this.invArr;
      this.validateInvDetail();
      if (this.invArr.length <= 0) {
        this.alert.content = "PLEASE Add Atlease Single Invocie .";
        this.$refs["addPop"].open();
        return false;
      }

      if (this.validateInv == false) {
        this.alert.content = "PLEASE ENTER ALL * DETAILS .";
        this.$refs["addPop"].open();
        return false;
      }

      let payload = {
        itemCode: "add_multi_inv_doc",
        invArr: this.invArr,
        invoiceDocDeatils: this.invoiceDocDeatils,
      };
      if (this.validateInv != false) {
        this.isLoading = true;
        AccountService.getAllAccountList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.exp_id != "" && data.exp_id != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on addInvDetailForm Error: ", error);
          });
      }
    },

    getSingleInvDetail() {
      this.isLoading = true;
      let payload = {
        allModuleId: this.$sessionsStorage.get("port_allModuleId"),
        JOBType: this.$sessionsStorage.get("port_JOBType"),
        exp_id: this.$sessionsStorage.get("exp_id"),
        itemCode: "Single_portExpense",
      };

      AccountService.getAllAccountList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.singleInvDetail.length > 0) {
              this.ExpenseData = data.singleInvDetail;
            }
            if (data.assignmentData.length > 0) {
              this.assignmentData = data.assignmentData;
            }

            if (data.singleInvDetail.length > 0) {
              Object.keys(this.invArr).map((x) => {
                this.invArr[x] = data.singleInvDetail[0][x] || "";
              });
              this.InvDetailArray = data.singleInvDetail;

              let i = 0;
              data.singleInvDetail.forEach((element) => {
                data.AssUploadExpenseData.forEach((element2) => {
                  if (element.exp_doc_link == element2.documentLink) {
                    element.otherDocName = element2.otherDocName;
                  }
                });

                var date2 = new Date(element.invDate);
                var result2 =
                  "" +
                  date2.getFullYear() +
                  (date2.getMonth() + 1 > 9 ? "-" : "-0") +
                  (date2.getMonth() + 1) +
                  (date2.getDate() > 9 ? "-" : "-0") +
                  date2.getDate();
                var invDate = "";
                if (result2 == "1970-01-01") {
                  var invDate = "";
                } else {
                  var invDate = result2;
                }
                this.InvDetail.exp_id = element.exp_id || "";
                element["invDate"] = invDate || "";
                element["exp_id"] = element.exp_id || "";
                element["allModuleId"] = element.allModuleId || "";
                element["invType"] = element.exp_type || "";
                element["invAmount"] = element.exp_amount || "";
                element["invCurrency"] = element.exp_Currency || "";
                element["invSlineUpload"] = element.exp_doc_link || "";
                element["invRemarks"] = element.exp_remarks || "";
                element["createdBy"] = element.createdBy || "";
                element["updatedBy"] = element.updatedBy || "";
                element["created_at"] = element.created_at || "";
                this.invArr.push(element);
                i++;
              });
            }
            console.log(" Single Port Expense response=>", this.invArr);
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single Port Expense Error: ", error);
        });
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.checkbox-inline {
  display: inline-flex;
  align-items: center;
}

.checkbox-inline .form-check-input {
  margin-right: 5px; /* Adjust as needed */
}
</style>



// WEBPACK FOOTER //
// addMultiInv.vue?20b5e9d8